<template>
  <EntitySearchPopover
    data-testid="tagsSearchPopover-popover-root"
    itemKey="id"
    :allowEmptySelection="true"
    :allowSearchScopeChange="false"
    :items="sortedTags"
    :localFilter="true"
    :localFilterFields="['name']"
    :multiple="true"
    :open="open"
    :placeholder="$t('common.search')"
    :resultsHeaderText="$t('common.tag_other')"
    :selectedItems="selectedTags"
    @openChange="$emit('openChange', $event)"
    @remove="handleRemove"
    @select="handleSelect"
  >
    <template v-slot:default>
      <slot />
    </template>

    <template v-slot:item="{ item, isSelected }">
      <v-list-item
        data-testid="tagsSearchPopover-listItem-option"
        :class="{ 'tags-search-popover__item--selected': isSelected }"
        @click="isSelected ? handleRemove(item) : handleSelect(item)"
      >
        <v-list-item-content data-testid="tagsSearchPopover-content-option">
          <v-list-item-title data-testid="tagsSearchPopover-text-optionName">
            {{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-slot:selectedItem="{ item }">
      <v-list-item
        class="tags-search-popover__item--selected"
        data-testid="tagsSearchPopover-listItem-selected"
        @click="handleRemove(item)"
      >
        <v-list-item-content data-testid="tagsSearchPopover-content-selected">
          <v-list-item-title data-testid="tagsSearchPopover-text-selectedName">
            {{ item.name }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </EntitySearchPopover>
</template>

<script>
import EntitySearchPopover from '@/components/EntitySearchPopover.vue'

export default {
  name: 'TagsSearchPopover',

  components: {
    EntitySearchPopover,
  },

  props: {
    open: {
      type: Boolean,
      default: false,
    },
    selectedTagIds: {
      type: Array,
      default: () => [],
    },
    tags: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    sortedTags() {
      return [...this.tags]
        .map(tag => ({
          ...tag,
          id: tag?._id ?? tag?.id,
        }))
        .sort((a, b) => String(a?.name ?? '').localeCompare(String(b?.name ?? '')))
    },

    selectedTags() {
      return this.sortedTags.filter(tag => this.selectedTagIds.includes(tag.id))
    },
  },

  methods: {
    handleSelect(tag) {
      this.$emit('toggle-tag', tag?.id ?? tag?._id)
    },

    handleRemove(tag) {
      this.$emit('toggle-tag', tag?.id ?? tag?._id)
    },

    isSelected(tag) {
      return this.selectedTagIds.includes(tag?.id ?? tag?._id)
    },
  },
}
</script>

<style lang="scss">
.tags-search-popover {
  &__item--selected {
    background-color: rgba(25, 118, 210, 0.12);

    .v-list-item__title {
      color: #1976d2;
      font-weight: 500;
    }
  }
}
</style>
